import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '..';
import {
  PenSectionOverviewShape,
  PenSectionsResponseShape,
  PenShape,
  PensResponseShape,
  PenTypesResponseShape,
  UpdatePenOverviewFieldsShape,
} from 'models/pens';

export const PensApi = createApi({
  reducerPath: 'pensApi',
  tagTypes: [
    'pens',
    'pen',
    'pen-types',
    'pen-sections',
    'pen-sections-overview',
  ],
  baseQuery,
  endpoints: (builder) => ({
    getPensTableData: builder.query<PensResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['pens'],
    }),
    getPen: builder.query<PenShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['pen'],
    }),
    getPenTypes: builder.query<PenTypesResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['pen-types'],
    }),
    getPenSections: builder.query<PenSectionsResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['pen-sections'],
    }),
    deletePenSection: builder.mutation<void, string>({
      query: (url) => ({
        url: url,
        method: 'DELETE',
      }),
    }),
    getPenOverview: builder.query<PenSectionOverviewShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['pen-sections-overview'],
    }),
    updatePenOverviewFields: builder.mutation<
      void,
      UpdatePenOverviewFieldsShape
    >({
      query: ({ url, ...otherBodyprops }) => ({
        url: url,
        method: 'PATCH',
        body: otherBodyprops,
      }),
      invalidatesTags: ['pen-sections-overview'],
    }),
  }),
});

export const {
  useGetPensTableDataQuery,
  useGetPenQuery,
  useGetPenTypesQuery,
  useGetPenSectionsQuery,
  useGetPenOverviewQuery,
  useUpdatePenOverviewFieldsMutation,
  useDeletePenSectionMutation,
} = PensApi;
